import { Component, Input, OnInit } from "@angular/core";
import { BeautifyDisplayStringPipe } from "src/app/pipes/beautify-display-string/beautify-display-string.pipe";

@Component({
    selector: "app-tag",
    templateUrl: "./tag.component.html",
    styleUrls: ["./tag.component.scss"],
})
export class TagComponent implements OnInit {
    @Input() public tags: string;

    public showTagText: string;
    public tooltipText = "";
    public multipleTags = false;

    private _tagsArray: string[] = [];

    private _beautifyDisplayStringPipe: BeautifyDisplayStringPipe = new BeautifyDisplayStringPipe();

    ngOnInit(): void {
        this._tagsArray = this.tags.split(",");

        if (this._tagsArray.length == 1 && this._tagsArray[0] == "") this._tagsArray = ["No Tags"];

        if (this._tagsArray.length > 1) this.multipleTags = true;

        if (!this.multipleTags) this.showTagText = this._tagsArray[0];
        else this.showTagText = "+" + this._tagsArray.length;

        let on = 0;
        this._tagsArray.forEach((tag) => {
            if (on == this._tagsArray.length - 1) this.tooltipText += this._beautifyDisplayStringPipe.transform(tag);
            else this.tooltipText += this._beautifyDisplayStringPipe.transform(tag) + ", ";
            on++;
        });
    }
}
